import { render, staticRenderFns } from "./MarginItemsSection.vue?vue&type=template&id=33ae0995&"
import script from "./MarginItemsSection.vue?vue&type=script&lang=js&"
export * from "./MarginItemsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports